import { env } from "../../config";
import configDev from "./config.json";
import configProd from "./config_prod.json";

export const loadConfig =  () => {
    if (env === "development") {
      return configDev;
    } else {
      return configProd;
    }
};